import { forwardRef } from 'react';
import s from './Input.module.scss';
import PhoneInput from '@/app/components/ui/inputs/Input/PhoneInput';

const Input = forwardRef(
  (
    {
      type = 'text',
      name,
      placeholder,
      className,
      required = false,
      value = '',
      defaultValue = '',
      onChange,
      onChangePhone,
      ...props
    },
    ref
  ) => {
    const inputClassname = `${s.input} ${className || ''}`;
    return (
      <>
        {type === 'tel' ? (
          <PhoneInput
            inputClass={inputClassname}
            value={value}
            onChange={onChangePhone}
            name={name}
            required={required}
          />
        ) : (
          <input
            ref={ref}
            id={name}
            name={name}
            type={type}
            placeholder={placeholder}
            className={inputClassname}
            required={required}
            autoComplete="off"
            value={value}
            onChange={onChange}
            {...props}
          />
        )}
      </>
    );
  }
);

Input.displayName = 'Input';

export default Input;
